import component from './ProviderLogos';

export default component;
